module.exports = __webpack_public_path__ + "img/622.That_dirty.cc549613.svg";